import React from 'react';
import GenericModal from '../GenericModal';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactHlsPlayer from 'react-hls-player';
import 'video-react/dist/video-react.css';

const PlayerStyled = styled(ReactHlsPlayer)`
  background: black;
  max-height: 90vh;
`

const VideoPlayModal = ({
  children,
  thumbnail,
  video,
  ...other
}) => {
  return (
    <GenericModal {...other}>
      <PlayerStyled
        src={video}
        autoPlay={true}
        controls={true}
        width="95%"
        height="auto"
      />
    </GenericModal>
  );
}

VideoPlayModal.propTypes = {
  header: PropTypes.string,
  onClick: PropTypes.func,
  thumbnail: PropTypes.string,
  video: PropTypes.string,
};

VideoPlayModal.defaultProps = {
}

export default VideoPlayModal;
